import { useQuery } from "@tanstack/react-query";
import eventsService from "services/admin/eventsService";

export const useGetTicketEvents = (ticketID: string) => {
    return useQuery({
        queryKey: ['events', 'ticket', ticketID],
        queryFn: async () => {
            const response = await eventsService.getTicketEvents(ticketID)
            return response.data?.rows || []
        },
        refetchOnWindowFocus: false,
        enabled: !!ticketID,
    })
}
